import { getMultipleLotteryResultRequest, lottery } from 'lib/apis';
import { DELIVER_STATUS } from 'lib/constants/award';

interface UseSingleLotteryProps {
  activityId: number;
}

export const sigleDraw = async ({ activityId }: UseSingleLotteryProps) => {
  // 先检查是否有待领取的礼包
  const pendingResult = await getMultipleLotteryResultRequest({ actId: activityId });

  if (pendingResult?.code !== 0) {
    return pendingResult;
  }

  if (pendingResult?.data?.drawResult?.length > 0) {
    const drawResult = pendingResult.data.drawResult[0];
    // 检查是否有未领取的礼包
    if (drawResult.deliverStatus !== DELIVER_STATUS.DELIVERED) {
      return pendingResult;
    }
  }

  // 没有待领取的礼包，执行抽奖
  const lotteryResult = await lottery({ actId: activityId });

  return lotteryResult;
};
